import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithInterceptor } from './base-query'

export const baseApi = createApi({
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ['Products', 'Product', 'User', 'Hostnames', 'Billing', 'Customers'],
  endpoints: () => ({}),
})
